import axios from 'axios';

export function getDocuments() {
    return axios.get(
        `${process.env.REACT_APP_REPO}/v2/repo_aden/students/me/requirements`
    );
}

export async function saveDocument(pdf) {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_SISAPI}/v2/acropolis/student_document`,
            pdf
        );
        return response;
    } catch (error) {
        console.error('Error saving document:', error);
        return error;
    }
}

export async function updateDocument(data) {
    try {
        const response = await axios.patch(
            `${process.env.REACT_APP_SISAPI}/v2/acropolis/student_document/${data.id}`,
            data.file
        );
        return response;
    } catch (error) {
        console.error('Error saving document:', error);
        return error;
    }
}

export const getDocumentCheck = async (partner_id, sis_id) => {
    const URL = `${process.env.REACT_APP_SISAPI}/v1/acropolis/documentacion_estudiantes/state_documentation?partner_id=${partner_id}&sis_id=${sis_id}`;

    try {
        const response = await axios.get(URL);
        return response.data.response_data;
    } catch (error) {
        return null;
    }
};

export const postDocument = async (documentTypeId) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_REPO}/v1/repo_aden/sign/documents/${documentTypeId}`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data.response.sign_url;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
};
